import { Link } from "react-router-dom";
import { getCategoryName, getLatestArticles } from "@/utils/news";

const breakingList = getLatestArticles(8)
  .filter((item) => item.category === "tufa" || item.category === "kuaixun")
  .slice(0, 3);

export default function BreakingBand() {
  return (
    <section aria-label="突发速报" className="mt-10 border-y border-accent-200 bg-accent-100">
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-6 px-4 py-8 md:px-6 lg:grid-cols-[260px_1fr]">
        <div>
          <span className="flex w-fit items-center gap-2 rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
            <span className="pulse-dot h-1.5 w-1.5 rounded-full bg-background-50" />
            突发速报
          </span>
          <h2 className="mt-3 font-serif-cn text-2xl font-bold leading-snug text-foreground-950">
            第一时间，
            <br />
            跟进正在发生的事
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            突发消息随更新补充核实进展，建议开启刷新关注。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          {breakingList.map((item, index) => (
            <article
              key={item.id}
              className="flex flex-col rounded-lg border border-accent-200 bg-background-50 p-5"
            >
              <div className="mb-2 flex items-center justify-between">
                <span className="text-xs font-medium text-primary-600">
                  {getCategoryName(item.category)}
                </span>
                <span className="text-xs text-foreground-500">
                  {String(index + 1).padStart(2, "0")}
                </span>
              </div>
              <h3 className="font-serif-cn text-base font-semibold leading-snug text-foreground-950">
                <Link to={`/article/${item.id}`} className="transition hover:text-primary-600">
                  {item.title}
                </Link>
              </h3>
              <p className="mt-2 line-clamp-2 flex-1 text-sm text-foreground-600">{item.summary}</p>
              <span className="mt-3 flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-time-line" />
                {item.publishedAt}
              </span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}